// 修正後的標頭名稱 (使用您提供的精確中文標頭)
const HEADERS = [
    "\u602A\u7269\u540D\u7A31",
    "\u7B49\u7D1A",
    "\u751F\u547D\u503C",
    "\u57FA\u790E\u7D93\u9A57",
    "\u6389\u843D\u7269\u54C1"
];
let MONSTER_DROPS_RAW = [];
let MONSTER_DROPS_MERGED = [];
// 元素參考
const resultsGrid = document.getElementById('resultsGrid');
const searchInput = document.getElementById('searchInput');
const dataStatus = document.getElementById('dataStatus');
const levelFilterControls = document.getElementById('levelFilterControls');
const themeToggleContainer = document.getElementById('themeToggleContainer');
// *** 新增：回到最上按鈕參考 ***
const scrollToTopBtn = document.getElementById('scrollToTopBtn');
// Min/Max 等級輸入框參考
let minLevelInput;
let maxLevelInput;
// --- 主題切換相關函式 (略) ---
// ... (此處省略 loadThemePreference 和 toggleTheme 函式，請保留您檔案中的內容)
// 在頁面載入時從 Local Storage 讀取主題偏好
function loadThemePreference() {
    // 預設為 'light'
    const currentTheme = localStorage.getItem('theme') || 'light';
    document.body.className = currentTheme + '-theme';
    // 更新按鈕文字 (在初始化按鈕後處理)
    const toggleBtn = document.getElementById('themeToggleBtn');
    if (toggleBtn) toggleBtn.textContent = currentTheme === 'light' ? "\u591C\u9593\u6A21\u5F0F" : "\u65E5\u9593\u6A21\u5F0F";
}
// 切換主題並儲存偏好
function toggleTheme() {
    const isDark = document.body.classList.contains('dark-theme');
    const newTheme = isDark ? 'light' : 'dark';
    // 更新 body class
    document.body.className = newTheme + '-theme';
    // 儲存偏好
    localStorage.setItem('theme', newTheme);
    // 更新按鈕文字
    const toggleBtn = document.getElementById('themeToggleBtn');
    if (toggleBtn) toggleBtn.textContent = newTheme === 'light' ? "\u591C\u9593\u6A21\u5F0F" : "\u65E5\u9593\u6A21\u5F0F";
}
// --- 新增：回到最上功能函式 ---
// 滾動回頂部
function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滾動
    });
}
// 監聽滾動事件以顯示/隱藏按鈕
function toggleScrollToTopButton() {
    // 當垂直滾動超過 300 像素時顯示按鈕
    if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) scrollToTopBtn.classList.add('show');
    else scrollToTopBtn.classList.remove('show');
}
// --- 核心 CSV 解析函式 (略) ---
// ... (此處省略 loadData, mergeMonsterDrops, highlightText 函式，請保留您檔案中的內容)
async function loadData() {
    const CSV_FILE = 'data.csv';
    try {
        loadThemePreference();
        dataStatus.textContent = "\u6578\u64DA\u8F09\u5165\u4E2D...";
        const response = await fetch(CSV_FILE);
        if (!response.ok) {
            dataStatus.textContent = `\u{932F}\u{8AA4}: \u{7121}\u{6CD5}\u{8F09}\u{5165}\u{6578}\u{64DA} (${response.status} ${response.statusText})\u{3002}\u{8ACB}\u{6AA2}\u{67E5} data.csv \u{6A94}\u{6848}\u{662F}\u{5426}\u{5B58}\u{5728}\u{3002}`;
            return;
        }
        const csvText = await response.text();
        const normalizedText = csvText.trim().replace(/^\uFEFF/, '');
        const lines = normalizedText.split(/\r?\n/);
        if (lines.length <= 1) {
            dataStatus.textContent = "\u6578\u64DA\u8F09\u5165\u6210\u529F\uFF0C\u5171 0 \u7B46\u8A18\u9304\u3002";
            initializeControls();
            return;
        }
        const actualHeaders = lines[0].split(',').map((h)=>h.trim());
        if (actualHeaders.length !== HEADERS.length) {
            dataStatus.textContent = `\u{932F}\u{8AA4}: \u{6B04}\u{4F4D}\u{6578}\u{4E0D}\u{5339}\u{914D}\u{FF01}\u{9810}\u{671F} ${HEADERS.length} \u{6B04}\u{4F4D} (${HEADERS.join(', ')})\u{FF0C}\u{5BE6}\u{969B}\u{627E}\u{5230} ${actualHeaders.length} \u{6B04}\u{4F4D} (${actualHeaders.join(', ')} )\u{3002}`;
            return;
        }
        MONSTER_DROPS_RAW = [];
        for(let i = 1; i < lines.length; i++){
            const line = lines[i].trim();
            if (!line) continue;
            const values = line.split(',').map((v)=>v.trim());
            if (values.length === actualHeaders.length) {
                const row = {};
                actualHeaders.forEach((header, index)=>{
                    row[header] = values[index];
                });
                MONSTER_DROPS_RAW.push(row);
            }
        }
        MONSTER_DROPS_MERGED = mergeMonsterDrops(MONSTER_DROPS_RAW);
        dataStatus.textContent = `\u{6578}\u{64DA}\u{8F09}\u{5165}\u{6210}\u{529F}\u{FF0C}\u{5171} ${MONSTER_DROPS_MERGED.length} \u{7B46}\u{602A}\u{7269}\u{8A18}\u{9304}\u{3002}`;
        renderTable(MONSTER_DROPS_MERGED);
        initializeControls();
    } catch (error) {
        dataStatus.textContent = "\u767C\u751F\u81F4\u547D\u932F\u8AA4\uFF0C\u8ACB\u6AA2\u67E5\u700F\u89BD\u5668 Console\u3002";
        console.error("An error occurred during data loading or parsing:", error);
    }
}
function mergeMonsterDrops(rawDrops) {
    const mergedData = new Map();
    rawDrops.forEach((item)=>{
        const monsterName = item["\u602A\u7269\u540D\u7A31"];
        if (!mergedData.has(monsterName)) mergedData.set(monsterName, {
            "\u602A\u7269\u540D\u7A31": monsterName,
            "\u7B49\u7D1A": item["\u7B49\u7D1A"],
            "\u751F\u547D\u503C": item["\u751F\u547D\u503C"],
            "\u57FA\u790E\u7D93\u9A57": item["\u57FA\u790E\u7D93\u9A57"],
            "\u6389\u843D\u7269\u54C1": []
        });
        const dropItem = item["\u6389\u843D\u7269\u54C1"].trim();
        if (dropItem && !mergedData.get(monsterName)["\u6389\u843D\u7269\u54C1"].includes(dropItem)) mergedData.get(monsterName)["\u6389\u843D\u7269\u54C1"].push(dropItem);
    });
    return Array.from(mergedData.values());
}
function highlightText(text, query) {
    if (!query) return text;
    const regex = new RegExp(`(${query})`, 'gi');
    return text.replace(regex, (match)=>`<span class="highlight">${match}</span>`);
}
function renderTable(data) {
    resultsGrid.innerHTML = '';
    if (data.length === 0) {
        resultsGrid.innerHTML = '<div class="no-results">\u67E5\u7121\u8CC7\u6599\u3002</div>';
        return;
    }
    const currentQuery = searchInput.value.trim();
    data.forEach((item)=>{
        const dropListHTML = item["\u6389\u843D\u7269\u54C1"].map((drop)=>{
            const highlightedDrop = highlightText(drop, currentQuery);
            return `<span>${highlightedDrop}</span>`;
        }).join('');
        const fullName = item["\u602A\u7269\u540D\u7A31"].trim();
        let englishName = fullName;
        let chineseName = '';
        const match = fullName.match(/(.*)\s*\(([^)]+)\)/);
        if (match) {
            englishName = match[1].trim();
            chineseName = match[2].trim();
        } else {
            englishName = fullName;
            chineseName = '';
        }
        const highlightedEn = highlightText(englishName, currentQuery);
        const highlightedCn = highlightText(chineseName, currentQuery);
        const nameHTML = `
            <span class="name-en">${highlightedEn}</span>
            <span class="name-cn">${highlightedCn}</span>
        `;
        // --- 核心邏輯：計算 HP/EXP ---
        let hpPerExpValue = 'N/A';
        const hp = parseInt(item["\u751F\u547D\u503C"]);
        const exp = parseInt(item["\u57FA\u790E\u7D93\u9A57"]);
        const levelStr = item["\u7B49\u7D1A"].toLowerCase();
        if (levelStr === 'none' && item["\u751F\u547D\u503C"].toLowerCase() === 'none' && item["\u57FA\u790E\u7D93\u9A57"].toLowerCase() === 'none') hpPerExpValue = 'None';
        else if (!isNaN(hp) && !isNaN(exp) && exp > 0) hpPerExpValue = (hp / exp).toFixed(2);
        else hpPerExpValue = 'N/A';
        const statsHTML = `
            <div class="monster-stats">
                HP/EXP: <strong>${hpPerExpValue}</strong>
            </div>
        `;
        const cardHTML = `
            <div class="monster-card">
                <div class="monster-info-header">
                    <div class="name-container">
                        ${nameHTML} 
                    </div>
                    <span class="level">Lv. ${item["\u7B49\u7D1A"]}</span>
                    <span class="hp">HP: ${item["\u751F\u547D\u503C"]}</span>
                    <span class="exp">EXP: ${item["\u57FA\u790E\u7D93\u9A57"]}</span>
                </div>
                ${statsHTML} 
                <div class="drop-list">
                    ${dropListHTML}
                </div>
            </div>
        `;
        resultsGrid.insertAdjacentHTML('beforeend', cardHTML);
    });
}
// --- 重置等級篩選的函式 (略) ---
function resetLevelFilters() {
    if (minLevelInput) minLevelInput.value = '';
    if (maxLevelInput) maxLevelInput.value = '';
    applyFilters();
}
// --- 初始化所有控制項 ---
function initializeControls() {
    // 1. 生成等級篩選區塊 HTML
    levelFilterControls.innerHTML = `
        <label for="minLevelInput">\u{7B49}\u{7D1A}\u{FF1A}</label>
        <input type="number" id="minLevelInput" placeholder="\u{6700}\u{5C0F} Lv." min="1" class="level-input">
        <span class="level-separator">~</span>
        <input type="number" id="maxLevelInput" placeholder="\u{6700}\u{5927} Lv." min="1" class="level-input">
        <button id="resetLevelBtn" class="reset-button">\u{91CD}\u{7F6E}</button>
    `;
    // 2. 新增主題切換按鈕 HTML
    themeToggleContainer.innerHTML = `
        <button id="themeToggleBtn" class="theme-toggle-button"></button>
    `;
    // 3. 取得所有參考 
    minLevelInput = document.getElementById('minLevelInput');
    maxLevelInput = document.getElementById('maxLevelInput');
    const resetBtn = document.getElementById('resetLevelBtn');
    const themeToggleBtn = document.getElementById('themeToggleBtn');
    // 4. 綁定事件
    if (searchInput) searchInput.addEventListener('input', applyFilters);
    if (minLevelInput) minLevelInput.addEventListener('input', applyFilters);
    if (maxLevelInput) maxLevelInput.addEventListener('input', applyFilters);
    if (resetBtn) resetBtn.addEventListener('click', resetLevelFilters);
    if (themeToggleBtn) themeToggleBtn.addEventListener('click', toggleTheme);
    // *** 新增：綁定回到最上按鈕事件和滾動事件 ***
    if (scrollToTopBtn) scrollToTopBtn.addEventListener('click', scrollToTop);
    window.addEventListener('scroll', toggleScrollToTopButton);
    loadThemePreference();
    applyFilters();
}
// --- 應用篩選 (略) ---
function applyFilters() {
    const query = searchInput.value.trim();
    let minLevel = minLevelInput ? parseInt(minLevelInput.value) : 1;
    let maxLevel = maxLevelInput ? parseInt(maxLevelInput.value) : 999;
    minLevel = isNaN(minLevel) || minLevel < 1 ? 1 : minLevel;
    maxLevel = isNaN(maxLevel) || maxLevel < 1 ? 999 : maxLevel;
    let filtered = MONSTER_DROPS_MERGED;
    // 步驟一：自訂等級範圍過濾
    filtered = filtered.filter((item)=>{
        const levelStr = item["\u7B49\u7D1A"].toLowerCase();
        const level = parseInt(levelStr);
        if (!isNaN(level)) return level >= minLevel && level <= maxLevel;
        return true;
    });
    // 步驟二：單一文字搜尋過濾
    if (query.length > 0) {
        const lowerCaseQuery = query.toLowerCase();
        filtered = filtered.filter((item)=>{
            const monsterMatch = item["\u602A\u7269\u540D\u7A31"].toLowerCase().includes(lowerCaseQuery);
            const dropMatch = item["\u6389\u843D\u7269\u54C1"].some((dropItem)=>dropItem.toLowerCase().includes(lowerCaseQuery));
            return monsterMatch || dropMatch;
        });
    }
    renderTable(filtered);
    dataStatus.textContent = `\u{627E}\u{5230} ${filtered.length} \u{7B46}\u{8A18}\u{9304}\u{3002}`;
}
// --- 初始化 ---
document.addEventListener('DOMContentLoaded', loadData);

//# sourceMappingURL=chronodrop.40407ca4.js.map
